/* Savore — interactions ported from the approved design.
   The design was a client-side SPA; here the markup is rendered by Liquid and this
   file supplies the same behaviour on top of it. */
(function () {
  'use strict';

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const inr = (n) => '₹' + Math.round(n).toLocaleString('en-IN');

  /* ---------------- toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('on'), 2600);
  }

  /* ---------------- cart count ---------------- */
  function setCount(n) {
    const el = $('#count');
    if (!el) return;
    el.textContent = n;
    if (n > 0) el.removeAttribute('data-empty');
    else el.setAttribute('data-empty', '1');
  }

  async function refreshCount() {
    try {
      const r = await fetch('/cart.js');
      const c = await r.json();
      setCount(c.item_count);
      return c;
    } catch (e) {
      return null;
    }
  }

  /* ================= CART DRAWER ================= */
  /* One AJAX drawer, rendered once by snippets/savore-cart-drawer.liquid and
     driven entirely from /cart.js JSON, so the markup has a single renderer
     rather than one in Liquid and another here. */
  const drawer = (function () {
    const el = $('#savoreDrawer');
    const noop = { enabled: false, openWith() {}, openFetch() {}, close() {} };
    if (!el || typeof el.showModal !== 'function') return noop;

    const body = $('#sdBody', el);
    const foot = $('#sdFoot', el);
    const subtotalEl = $('#sdSubtotal', el);
    const countEl = $('#sdCount', el);
    const live = $('#sdLive', el);
    const browseUrl = el.dataset.browseUrl || '/collections/all';

    let lastTrigger = null;
    let busy = false;
    let mutated = false;

    const esc = (s) =>
      String(s == null ? '' : s).replace(
        /[&<>"']/g,
        (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]
      );

    const thumb = (url, w) => (url ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : '');

    /* Match the money format the rest of the storefront renders via
       snippets/savore-money.liquid, so the drawer agrees with the cart page it
       links to. inr() above uses Indian digit grouping and is left alone for
       the quick-order sheet. */
    const money = (cents) => '₹' + Math.round(cents / 100).toLocaleString('en-US');

    const say = (msg) => {
      if (live) live.textContent = msg;
    };

    /* Every product steps by one, from a minimum of one. */
    function lineHtml(item) {
      const title = esc(item.product_title || item.title);
      const variant =
        item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) + ' · ' : '';
      const img = item.image
        ? '<a href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true"><img src="' +
          esc(thumb(item.image, 160)) +
          '" alt="" width="76" height="58" loading="lazy"></a>'
        : '<span></span>';

      return (
        '<div class="sd-line" data-key="' + esc(item.key) + '">' +
        img +
        '<div class="sd-info">' +
        '<h3><a href="' + esc(item.url) + '">' + title + '</a></h3>' +
        '<p class="sd-var">' + variant + money(item.original_price) + ' each</p>' +
        '<div class="sd-row">' +
        '<span class="stepper">' +
        '<button type="button" data-dec aria-label="Decrease ' + title + '"' +
        (item.quantity <= 1 ? ' disabled' : '') +
        '>−</button>' +
        '<span data-qty>' + item.quantity + '</span>' +
        '<button type="button" data-inc aria-label="Increase ' + title + '">+</button>' +
        '</span>' +
        '<span class="sd-total">' + money(item.original_line_price) + '</span>' +
        '</div>' +
        '<button class="drop sd-rm" type="button" data-rm aria-label="Remove ' +
        title +
        ' from your gifting list">Remove</button>' +
        '</div>' +
        '</div>'
      );
    }

    function render(cart) {
      const items = (cart && cart.items) || [];
      const n = cart ? cart.item_count : 0;

      setCount(n);
      if (countEl) {
        countEl.textContent = n;
        if (n > 0) countEl.removeAttribute('data-empty');
        else countEl.setAttribute('data-empty', '1');
      }

      if (!items.length) {
        body.innerHTML =
          '<div class="sd-empty">' +
          '<h3>Nothing on your list yet</h3>' +
          '<p>Add hampers or pantry jars and we&rsquo;ll keep a running total right here.</p>' +
          '<a class="btn" href="' + esc(browseUrl) + '#nuts">Browse the collection</a>' +
          '</div>';
        foot.hidden = true;
        return;
      }

      body.innerHTML = items.map(lineHtml).join('');
      subtotalEl.textContent = money(cart.total_price);
      foot.hidden = false;
    }

    function open(trigger) {
      lastTrigger = trigger || document.activeElement;
      if (!el.open) el.showModal();
    }

    function close() {
      if (el.open) el.close();
    }

    async function change(key, quantity, lineEl) {
      if (busy) return;
      busy = true;
      if (lineEl) lineEl.dataset.busy = '1';
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        if (!res.ok) throw new Error(await res.text());
        const cart = await res.json();
        mutated = true;
        render(cart);
        say(quantity === 0 ? 'Removed from your gifting list.' : 'Quantity updated.');
      } catch (e) {
        toast('That could not be updated');
        const cart = await refreshCount();
        if (cart) render(cart);
      } finally {
        busy = false;
      }
    }

    body.addEventListener('click', (e) => {
      const line = e.target.closest('.sd-line');
      if (!line) return;
      const key = line.dataset.key;
      const qtyEl = $('[data-qty]', line);
      const qty = Number(qtyEl ? qtyEl.textContent.trim() : 0) || 0;

      if (e.target.closest('[data-rm]')) return change(key, 0, line);
      if (e.target.closest('[data-inc]')) return change(key, qty + 1, line);
      if (e.target.closest('[data-dec]')) return change(key, Math.max(1, qty - 1), line);
    });

    const closeBtn = $('#sdClose', el);
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* A click that lands on the dialog itself is a click on the backdrop. */
    el.addEventListener('click', (e) => {
      if (e.target === el) close();
    });

    /* Not every engine fires the dialog's native close request on Escape, so
       close explicitly too. close() no-ops when the drawer is already shut, so
       this is harmless where the native behaviour does work. */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && el.open) {
        e.preventDefault();
        close();
      }
    });

    el.addEventListener('close', () => {
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
      /* The /cart page renders these same lines server-side, so if the drawer
         changed the cart while that page sat behind it, bring the page level. */
      if (mutated && document.getElementById('cartForm')) location.reload();
    });

    return {
      enabled: true,
      close: close,
      openWith(cart, trigger) {
        render(cart);
        open(trigger);
      },
      async openFetch(trigger) {
        open(trigger);
        body.innerHTML = '<p class="sd-min" style="padding:32px 0;text-align:center">Loading&hellip;</p>';
        foot.hidden = true;
        const cart = await refreshCount();
        if (cart) render(cart);
        else
          body.innerHTML =
            '<p class="sd-min" style="padding:32px 0;text-align:center">Your list could not be loaded.</p>';
      }
    };
  })();

  /* Single add-to-cart path shared by the product page, the card quick-add and
     the bulk quick-order sheet. Opening the drawer is the confirmation, so the
     toast is kept for failures only. */
  async function addToCart(payload, btn) {
    const label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        let detail = '';
        try {
          detail = (await res.clone().json()).description || '';
        } catch (err) {}
        throw new Error(detail);
      }
      const cart = await refreshCount();
      if (drawer.enabled && cart) drawer.openWith(cart, btn);
      else toast('Added to your gifting list');
      return true;
    } catch (err) {
      toast(err && err.message ? String(err.message).slice(0, 140) : 'That could not be added');
      return false;
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = label;
      }
    }
  }

  /* The header "Gifting list" button opens the drawer instead of navigating.
     Its href stays as the no-JS fallback. */
  if (drawer.enabled) {
    $$('.list-btn').forEach((btn) => {
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.openFetch(btn);
      });
    });
  }

  /* ---------------- nav ---------------- */
  const burger = $('#burger');
  if (burger) {
    burger.addEventListener('click', () => {
      const links = $('#navLinks');
      const open = links.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------------- lightbox ---------------- */
  const lb = $('#lb');
  const lbImg = $('#lbImg');
  const zoom = $('#zoom');
  if (zoom && lb && lbImg) {
    zoom.addEventListener('click', () => {
      const img = $('img', zoom);
      if (!img) return;
      lbImg.src = img.dataset.full || img.src;
      lbImg.alt = img.alt;
      lb.classList.add('on');
    });
    lb.addEventListener('click', () => lb.classList.remove('on'));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') lb.classList.remove('on');
    });
  }

  /* ---------------- quick add from a card ---------------- */
  $$('form[data-quick-add]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const idInput = $('input[name="id"]', form);
      if (!idInput) return;
      addToCart({ id: Number(idInput.value), quantity: 1 }, $('button', form));
    });
  });

  /* ================= BROWSE PAGE ================= */
  const browse = $('#savoreBrowse');
  if (browse) {
    const views = {
      nuts: $('[data-view="nuts"]', browse),
      hampers: $('[data-view="hampers"]', browse),
      quick: $('[data-view="quick"]', browse)
    };
    const state = { cat: 'all', band: 'all', sort: 'low', q: '' };

    function showView(name) {
      Object.keys(views).forEach((k) => {
        if (views[k]) views[k].hidden = k !== name;
      });
      document.body.classList.toggle('has-bar', name === 'quick');
      $$('.nav-links a').forEach((a) => {
        const match = name === 'nuts' ? 'pantry' : 'collection';
        a.classList.toggle('on', a.dataset.r === match);
      });
    }

    function readHash() {
      const h = (location.hash || '').replace(/^#/, '');
      if (h === 'nuts') return showView('nuts');
      if (h === 'quick') return showView('quick');
      if (h === 'hampers-ritual') {
        state.cat = 'ritual';
        syncChips();
      } else if (h === 'hampers-gourmet') {
        state.cat = 'gourmet';
        syncChips();
      }
      showView('hampers');
      draw();
    }

    function syncChips() {
      $$('#catFilter .chip').forEach((c) =>
        c.setAttribute('aria-pressed', c.dataset.cat === state.cat ? 'true' : 'false')
      );
      $$('#priceFilter .chip').forEach((c) =>
        c.setAttribute('aria-pressed', c.dataset.band === state.band ? 'true' : 'false')
      );
    }

    const bandOf = (p) => (p < 1500 ? 'a' : p <= 3000 ? 'b' : 'c');

    function draw() {
      const grid = $('#grid', browse);
      if (!grid) return;
      const cards = $$('[data-piece]', grid);
      const needle = state.q.trim().toLowerCase();
      let visible = 0;

      cards.forEach((card) => {
        const price = Number(card.dataset.price || 0);
        const okCat = state.cat === 'all' || card.dataset.cat === state.cat;
        const okBand = state.band === 'all' || bandOf(price) === state.band;
        const okQ = !needle || (card.dataset.search || '').toLowerCase().includes(needle);
        const show = okCat && okBand && okQ;
        card.hidden = !show;
        if (show) visible++;
      });

      // sort by reordering the DOM
      const sorted = cards.slice().sort((a, b) => {
        if (state.sort === 'low') return a.dataset.price - b.dataset.price;
        if (state.sort === 'high') return b.dataset.price - a.dataset.price;
        return (a.dataset.name || '').localeCompare(b.dataset.name || '');
      });
      sorted.forEach((c) => grid.appendChild(c));

      const empty = $('#empty', browse);
      if (empty) empty.hidden = visible > 0;

      const count = $('#resultCount', browse);
      if (count) {
        const total = Number(browse.dataset.hamperCount || cards.length);
        count.textContent =
          visible === total
            ? 'All ' + total + ' hampers, ' + (browse.dataset.rangeLabel || '')
            : visible + ' hamper' + (visible === 1 ? '' : 's') + ' match';
      }

      const qx = $('#qx', browse);
      if (qx) qx.hidden = !state.q;
    }

    $$('#catFilter .chip', browse).forEach((chip) =>
      chip.addEventListener('click', () => {
        state.cat = chip.dataset.cat;
        syncChips();
        draw();
      })
    );
    $$('#priceFilter .chip', browse).forEach((chip) =>
      chip.addEventListener('click', () => {
        state.band = chip.dataset.band;
        syncChips();
        draw();
      })
    );
    const sortSel = $('#sort', browse);
    if (sortSel)
      sortSel.addEventListener('change', () => {
        state.sort = sortSel.value;
        draw();
      });
    const qInput = $('#q', browse);
    if (qInput)
      qInput.addEventListener('input', () => {
        state.q = qInput.value;
        draw();
      });
    const qx = $('#qx', browse);
    if (qx)
      qx.addEventListener('click', () => {
        state.q = '';
        qInput.value = '';
        draw();
      });

    /* ---- quick order sheet ---- */
    const qRows = $$('[data-row]', browse);
    function qRecalc() {
      let total = 0;
      let boxes = 0;
      qRows.forEach((row) => {
        const qty = Number($('[data-q]', row).value || 0);
        const price = Number(row.dataset.price || 0);
        const line = qty * price;
        $('[data-line]', row).textContent = line ? inr(line) : '—';
        total += line;
        boxes += qty;
      });
      const t = $('#qTotal', browse);
      const c = $('#qCount', browse);
      if (t) t.firstChild.nodeValue = inr(total);
      if (c)
        c.textContent = boxes
          ? boxes + ' boxes across ' + qRows.filter((r) => Number($('[data-q]', r).value) > 0).length + ' hampers'
          : 'nothing selected yet';
    }
    qRows.forEach((row) => $('[data-q]', row).addEventListener('input', qRecalc));

    const qClear = $('#qClear', browse);
    if (qClear)
      qClear.addEventListener('click', () => {
        qRows.forEach((r) => ($('[data-q]', r).value = 0));
        qRecalc();
      });

    const qAdd = $('#qAdd', browse);
    if (qAdd)
      qAdd.addEventListener('click', async () => {
        const items = qRows
          .map((r) => ({ id: Number(r.dataset.variant), quantity: Number($('[data-q]', r).value || 0) }))
          .filter((i) => i.quantity > 0);
        if (!items.length) return toast('Put a quantity against a hamper first');
        const ok = await addToCart({ items: items }, qAdd);
        if (ok) {
          qRows.forEach((r) => ($('[data-q]', r).value = 0));
          qRecalc();
        }
      });

    window.addEventListener('hashchange', readHash);
    readHash();
    qRecalc();
  }

  /* ================= PRODUCT PAGE ================= */
  const stepCfg = $('#savoreStepper');
  if (stepCfg) {
    const step = Number(stepCfg.dataset.step || 1);
    const min = Number(stepCfg.dataset.min || 1);
    const label = $('#qty');
    const input = $('#qtyInput');
    let qty = min;

    const paint = () => {
      label.textContent = qty;
      input.value = qty;
    };
    $('#minus').addEventListener('click', () => {
      qty = Math.max(min, qty - step);
      paint();
    });
    $('#plus').addEventListener('click', () => {
      qty += step;
      paint();
    });
    paint();
  }

  // variant pills
  const opts = $('#variantOpts');
  if (opts) {
    $$('.opt-btn', opts).forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        $$('.opt-btn', opts).forEach((b) => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        $('#variantId').value = btn.dataset.variant;
        const price = $('#pdPrice');
        if (price) price.textContent = btn.dataset.price;
        const size = $('#pdSize');
        if (size) size.textContent = btn.dataset.title;
      });
    });
  }

  // add to cart without leaving the page
  const addForm = $('#savoreAddForm');
  if (addForm) {
    addForm.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(
        { id: Number($('#variantId').value), quantity: Number($('#qtyInput').value) },
        $('#addBtn')
      );
    });
  }

  /* ================= GIFTING LIST ================= */
  const cartForm = $('#cartForm');
  if (cartForm) {
    async function change(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error(await res.text());
      location.reload();
    }

    $$('[data-line-row]', cartForm).forEach((row) => {
      const key = row.dataset.key;
      const step = Number(row.dataset.step || 1);
      const current = () => Number($('[data-qty]', row).textContent.trim());

      const inc = $('[data-inc="' + CSS.escape(key) + '"]', row);
      const dec = $('[data-dec="' + CSS.escape(key) + '"]', row);
      const rm = $('[data-remove="' + CSS.escape(key) + '"]', row);

      if (inc) inc.addEventListener('click', () => change(key, current() + step));
      if (dec)
        dec.addEventListener('click', () => {
          const next = current() - step;
          change(key, next < step ? 0 : next);
        });
      if (rm) rm.addEventListener('click', () => change(key, 0));

      const toggle = $('[data-open]', row);
      const panel = $('[data-panel]', row);
      if (toggle && panel) toggle.addEventListener('click', () => (panel.hidden = !panel.hidden));

      const save = $('[data-saveprops]', row);
      if (save)
        save.addEventListener('click', async () => {
          const props = {};
          $$('[data-prop]', row).forEach((i) => {
            if (i.value) props[i.dataset.prop] = i.value;
          });
          save.disabled = true;
          try {
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: current(), properties: props })
            });
            if (!res.ok) throw new Error(await res.text());
            const msg = $('[data-propmsg]', row);
            if (msg) msg.textContent = 'Saved.';
            toast('Delivery details saved');
          } catch (e) {
            toast('That could not be saved');
          } finally {
            save.disabled = false;
          }
        });
    });

    /* WhatsApp + copy */
    const json = $('#savoreCartJson');
    if (json) {
      let data = { lines: [], subtotal: '' };
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {}
      const text =
        data.lines.length === 0
          ? "Hello Savore, I'd like to ask about your Diwali hampers."
          : "Hello Savore, I'd like a quote for:\n\n" +
            data.lines.map((l) => '• ' + l.title + ' (' + l.sub + ') — ' + l.qty + ' × ' + l.price).join('\n') +
            '\n\nSubtotal ' + data.subtotal + ' before GST.';

      const waList = $('#waList');
      const waBtn = $('#waBtn');
      const number = (waBtn && waBtn.href.match(/wa\.me\/(\d+)/) || [])[1] || '917022597447';
      const link = 'https://wa.me/' + number + '?text=' + encodeURIComponent(text);
      if (waList) waList.href = link;
      if (waBtn) waBtn.href = link;

      const hidden = $('#quoteList');
      if (hidden) hidden.value = text;

      const copy = $('#copyBtn');
      if (copy)
        copy.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(text);
            toast('List copied');
          } catch (e) {
            toast('Could not copy');
          }
        });
    }
  }
})();
